<template>
  <div class="comment__audit-compare-content comment__item-sprint">
    <div class="comment__item-sprint__content">
      <SprintLabel
        v-if="beforeTeamSprint"
        :sprint="beforeTeamSprint"
        class="is-opacity"
      />
      <span
        v-else
        class="is-opacity"
      >
        {{ itemTypeBacklogLabel("before") }} Backlog</span
      >
      <icon
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
      />
      <SprintLabel
        v-if="afterTeamSprint"
        :sprint="afterTeamSprint"
      />
      <span v-else>{{ itemTypeBacklogLabel("after") }} Backlog</span>
    </div>
    <div
      v-if="itemAuditRecord?.before?.status && itemAuditRecord?.after?.status"
      class="comment__item-sprint__content"
    >
      <StatusComponent
        :value="getStatusById(itemAuditRecord.before.status)"
        class="is-opacity"
      />
      <icon
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
      />
      <StatusComponent :value="getStatusById(itemAuditRecord.after.status)" />
    </div>
    <ReadMoreComponent
      v-if="structuredDescription"
      :id="comment.id"
      :key="comment.id"
      :numberOfLines="5"
      :text="structuredDescription.html"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useStore } from "vuex"

import ReadMoreComponent from "@/components/ReadMore/ReadMoreComponent.vue"
import SprintLabel from "@/components/SprintLabel/index.vue"
import StatusComponent from "@/components/StatusComponent/index.vue"

import { Comment, Status } from "@/models"
import { $t } from "@/plugins/i18n"
import { Getters } from "@/store"

const props = defineProps<{
  comment: Comment
}>()

const store = useStore()

const itemAuditRecord = computed(() => props.comment.itemAuditRecord)
const structuredDescription = computed(() => props.comment.structuredDescription)
const beforeTeamSprint = computed(() => {
  const before = props.comment.before
  return before?.sprintSequenceNumber != null
    ? {
        continuousSprint: before.continuousSprint,
        zeroSprint: before.sprintSequenceNumber === 0,
        sequenceNumber: before.sprintSequenceNumber,
        status: before.sprintStatus
      }
    : null
})
const afterTeamSprint = computed(() => {
  const after = props.comment.after
  return after?.sprintSequenceNumber != null
    ? {
        continuousSprint: after.continuousSprint,
        zeroSprint: after.sprintSequenceNumber === 0,
        sequenceNumber: after.sprintSequenceNumber,
        status: after.sprintStatus
      }
    : null
})

function getStatusById(statusId: string): Status {
  return store.getters[Getters.GET_STATUS_BY_ID](statusId)
}

function itemTypeBacklogLabel(state: "before" | "after") {
  const selectedState = props.comment[state]
  if (selectedState?.backlogPriority == null) return "Unprioritized"
  return $t(`backlog.itemTypeToBacklogName.${selectedState.itemType}`)
}
</script>
